import React, { useEffect } from 'react';
import { SvgIcon, useTheme, useMediaQuery } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import MenuIcon from '@material-ui/icons/Menu';
import { Link } from 'react-router-dom';
import HelpCenter from '../HelpCenter/HelpCenter';
import "./Sidebar.scss";

const useStyles = makeStyles(theme => ({
  sideBar: {
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    transition: 'width 0.3s ease-in-out',
    overflowX: 'hidden',
    zIndex: 9999,
  },
  menuToggle: {
    marginTop: 'auto',
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center'
  },
  toggleIcon: {
    cursor: 'pointer',
  }
}));

export default function Sidebar({ expanded, setExpanded, navLinks, setActiveNavLink }) {
  const theme = useTheme();
  const isTabletOrMobile = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    setExpanded(!isTabletOrMobile);
  }, [isTabletOrMobile]);

  const classes = useStyles();

  return (
    <div id="advisor-sidebar" className={`${classes.sideBar} ${expanded ? 'advisor-sidebar-expanded' : 'advisor-sidebar-collapsed'}`}>
      <div id="sidenav-head">
        <img alt="Covr Logo" src={process.env.PUBLIC_URL + "/AdvisorImages/covr-logo-white.svg"} />
        {expanded ? 
          (<SvgIcon component={MenuOpenIcon} className={classes.toggleIcon} onClick={() => setExpanded(false)} />) : 
          (<SvgIcon component={MenuIcon} className={classes.toggleIcon} onClick={() => setExpanded(true)} />)}
      </div>
      <div className="sidenav">
        {navLinks.map((item, index) => (
          <SidebarLink
            key={index}
            isActive={item.isActive}
            text={item.text}
            iconElement={<SvgIcon component={item.icon} color="secondary" />}
            link={item.link}
            setActiveNavLink={setActiveNavLink}
            index={index}
            expanded={expanded}
          />
        ))}
      </div>
      <HelpCenter expanded={expanded} />
    </div>
  );
}

function SidebarLink({ link, text, iconElement, isActive, setActiveNavLink, index, expanded }) {
  return (
    <Link className={isActive ? 'active' : ''} title={text.toString()} onClick={() => setActiveNavLink(index)} to={link}>
      {iconElement}&nbsp;{expanded ? <span>{text}</span> : null}
    </Link>
  );
}



// WEBPACK FOOTER //
// ./src/components/Layout/Sidebar.js